/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { headerProvisionalConfig } from '../../config/header.config';
export interface IHeaderProvisionalPluginMethods extends IPluginMethodMap {
  getHeaderProvisionalSync(args?: any): any;
}

export class HeaderProvisionalPlugin implements IAgentPlugin {
  readonly methods: IHeaderProvisionalPluginMethods;

  constructor() {
    this.methods = {
      getHeaderProvisionalSync: this.getHeaderProvisionalSync.bind(this),
    };
  }

  getHeaderProvisionalSync(args?: any) {
    return {
      header: headerProvisionalConfig,
    };
  }
}
